/* @flow */

import * as React from 'react';
import styled from '@emotion/styled';
import { isEmpty } from 'lodash/fp';
import { AutoSizer, Grid, MultiGrid } from 'react-virtualized';

import Tappable from '../../../components/commons/Tappable';
import NoHistory from './NoHistory';
import GlanceCell from './GlanceCell';
import GlanceHeading from './GlanceHeading';

type Props = {
  fixedColumnCount?: number,
  headerRowCount?: number,
  season: *,
  rowHeight?: number
};

type State = {
  expandedIndex: ?number
};

const Wrapper = styled.div(({ theme }) => ({
  backgroundColor: theme.color.white,
  fontSize: theme.fontSize.tiny,
  fontWeight: '300',
  flexGrow: 1,
  overflow: 'auto',
  width: '100%',
  [theme.mediaQuery.tabletLandscapeAndUp]: {
    height: 270
  }
}));

Grid.defaultProps.overscanColumnCount = 100; // HACK

class Glance extends React.PureComponent<Props, State> {
  props: Props;

  state: State = {
    expandedIndex: null
  };

  static defaultProps = {
    fixedColumnCount: 1,
    headerRowCount: 1,
    rowHeight: 32
  };

  componentDidUpdate(prevProps, prevState) {
    const { expandedIndex } = this.state;

    if (prevState.expandedIndex !== expandedIndex) {
      // [MC] bit of a hack I think, can't work out how else to update the expanded rows though...
      // react-virtualized pure components can be hard to break
      if (
        this.multiGrid.current &&
        typeof this.multiGrid.current.recomputeGridSize === 'function'
      ) {
        try {
          this.multiGrid.current.recomputeGridSize();
        } catch (err) {
          // do nothing
        }
      }
    }
  }

  multiGrid = React.createRef();

  onHeaderClick(index) {
    this.setState(state => ({ expandedIndex: state.expandedIndex === index ? null : index }));
  }

  render() {
    const { fixedColumnCount, headerRowCount, rowHeight, season } = this.props;
    const { expandedIndex } = this.state;

    if (isEmpty(season.overview)) {
      return <NoHistory name={season.playerName} />;
    }

    const categories = Object.keys(season.overview[0].stats).map(field =>
      season.categories.find(c => c.id === field)
    );

    const categoriesCount = categories.length;
    const rowCount = headerRowCount + season.overview.length;

    return (
      <Wrapper>
        <AutoSizer>
          {({ height, width }) => (
            <MultiGrid
              ref={this.multiGrid}
              cellRenderer={({ key, rowIndex, columnIndex, ...cellProps }) =>
                rowIndex === 0 ? (
                  <Tappable
                    component={GlanceHeading}
                    key={key}
                    onTap={() => {
                      this.onHeaderClick(columnIndex);
                    }}
                    expanded={expandedIndex === columnIndex}
                    categories={categories}
                    columnIndex={columnIndex}
                    {...cellProps}
                  />
                ) : (
                  <GlanceCell
                    key={key}
                    data={season.overview[rowIndex - 1]}
                    categories={categories}
                    columnIndex={columnIndex}
                    {...cellProps}
                  />
                )
              }
              columnCount={fixedColumnCount + categoriesCount}
              columnWidth={({ index }) => (expandedIndex === index ? 100 : 68)}
              fixedColumnCount={fixedColumnCount}
              fixedRowCount={headerRowCount}
              height={height}
              rowCount={rowCount}
              rowHeight={rowHeight}
              width={width}
            />
          )}
        </AutoSizer>
      </Wrapper>
    );
  }
}

export default Glance;
